module.exports = __webpack_public_path__ + "static/Map-home.b4f24827.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Map-home.png
// module id = 506
// module chunks = 213534597649335